/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';
import type { PaymentSplitStatusDto } from './PaymentSplitStatusDto';
import {
    PaymentSplitStatusDtoFromJSON,
    PaymentSplitStatusDtoFromJSONTyped,
    PaymentSplitStatusDtoToJSON,
    PaymentSplitStatusDtoToJSONTyped,
} from './PaymentSplitStatusDto';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';
import type { CardDataDto } from './CardDataDto';
import {
    CardDataDtoFromJSON,
    CardDataDtoFromJSONTyped,
    CardDataDtoToJSON,
    CardDataDtoToJSONTyped,
} from './CardDataDto';

/**
 * 
 * @export
 * @interface InhousePaymentDto
 */
export interface InhousePaymentDto {
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    commissionAmount: string;
    /**
     * 
     * @type {Date}
     * @memberof InhousePaymentDto
     */
    created: Date;
    /**
     * 
     * @type {Currency}
     * @memberof InhousePaymentDto
     */
    currency: Currency;
    /**
     * 
     * @type {number}
     * @memberof InhousePaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    grossAmount: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    grossAmountAfterAddingTerminalTip: string;
    /**
     * 
     * @type {InhousePaymentDtoLatestEventCodeEnum}
     * @memberof InhousePaymentDto
     */
    latestEventCode: InhousePaymentDtoLatestEventCodeEnum;
    /**
     * 
     * @type {PaymentState}
     * @memberof InhousePaymentDto
     */
    latestState: PaymentState;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    netAmount: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    orderReference: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    paymentFeeAmount: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof InhousePaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {Array<PaymentSplitStatusDto>}
     * @memberof InhousePaymentDto
     */
    paymentSplitStatuses: Array<PaymentSplitStatusDto>;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    pendingRefundAmount: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    refundableAmount: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    refundedAmount: string;
    /**
     * 
     * @type {string}
     * @memberof InhousePaymentDto
     */
    terminalTipAmount: string;
    /**
     * 
     * @type {Date}
     * @memberof InhousePaymentDto
     */
    updated: Date;
    /**
     * 
     * @type {CardDataDto}
     * @memberof InhousePaymentDto
     */
    cardData?: CardDataDto | null;
}


/**
 * @export
 */
export const InhousePaymentDtoLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type InhousePaymentDtoLatestEventCodeEnum = typeof InhousePaymentDtoLatestEventCodeEnum[keyof typeof InhousePaymentDtoLatestEventCodeEnum];


/**
 * Check if a given object implements the InhousePaymentDto interface.
 */
export function instanceOfInhousePaymentDto(value: object): value is InhousePaymentDto {
    if (!('commissionAmount' in value) || value['commissionAmount'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('grossAmount' in value) || value['grossAmount'] === undefined) return false;
    if (!('grossAmountAfterAddingTerminalTip' in value) || value['grossAmountAfterAddingTerminalTip'] === undefined) return false;
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('latestState' in value) || value['latestState'] === undefined) return false;
    if (!('netAmount' in value) || value['netAmount'] === undefined) return false;
    if (!('orderReference' in value) || value['orderReference'] === undefined) return false;
    if (!('paymentFeeAmount' in value) || value['paymentFeeAmount'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('paymentSplitStatuses' in value) || value['paymentSplitStatuses'] === undefined) return false;
    if (!('pendingRefundAmount' in value) || value['pendingRefundAmount'] === undefined) return false;
    if (!('refundableAmount' in value) || value['refundableAmount'] === undefined) return false;
    if (!('refundedAmount' in value) || value['refundedAmount'] === undefined) return false;
    if (!('terminalTipAmount' in value) || value['terminalTipAmount'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function InhousePaymentDtoFromJSON(json: any): InhousePaymentDto {
    return InhousePaymentDtoFromJSONTyped(json, false);
}

export function InhousePaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InhousePaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'commissionAmount': json['commissionAmount'],
        'created': (new Date(json['created'])),
        'currency': CurrencyFromJSON(json['currency']),
        'executingLocationId': json['executingLocationId'],
        'grossAmount': json['grossAmount'],
        'grossAmountAfterAddingTerminalTip': json['grossAmountAfterAddingTerminalTip'],
        'latestEventCode': json['latestEventCode'],
        'latestState': PaymentStateFromJSON(json['latestState']),
        'netAmount': json['netAmount'],
        'orderReference': json['orderReference'],
        'paymentFeeAmount': json['paymentFeeAmount'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentReference': json['paymentReference'],
        'paymentSplitStatuses': ((json['paymentSplitStatuses'] as Array<any>).map(PaymentSplitStatusDtoFromJSON)),
        'pendingRefundAmount': json['pendingRefundAmount'],
        'refundableAmount': json['refundableAmount'],
        'refundedAmount': json['refundedAmount'],
        'terminalTipAmount': json['terminalTipAmount'],
        'updated': (new Date(json['updated'])),
        'cardData': json['cardData'] === undefined ? undefined : json['cardData'] === null ? null : CardDataDtoFromJSON(json['cardData']),
    };
}

export function InhousePaymentDtoToJSON(json: any): InhousePaymentDto {
    return InhousePaymentDtoToJSONTyped(json, false);
}

export function InhousePaymentDtoToJSONTyped(value?: InhousePaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'commissionAmount': value['commissionAmount'],
        'created': value['created'].toISOString(),
        'currency': CurrencyToJSON(value['currency']),
        'executingLocationId': value['executingLocationId'],
        'grossAmount': value['grossAmount'],
        'grossAmountAfterAddingTerminalTip': value['grossAmountAfterAddingTerminalTip'],
        'latestEventCode': value['latestEventCode'],
        'latestState': PaymentStateToJSON(value['latestState']),
        'netAmount': value['netAmount'],
        'orderReference': value['orderReference'],
        'paymentFeeAmount': value['paymentFeeAmount'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentReference': value['paymentReference'],
        'paymentSplitStatuses': ((value['paymentSplitStatuses'] as Array<any>).map(PaymentSplitStatusDtoToJSON)),
        'pendingRefundAmount': value['pendingRefundAmount'],
        'refundableAmount': value['refundableAmount'],
        'refundedAmount': value['refundedAmount'],
        'terminalTipAmount': value['terminalTipAmount'],
        'updated': value['updated'].toISOString(),
        'cardData': CardDataDtoToJSON(value['cardData']),
    };
}

